import { useEffect, useState } from "react";
import { applyPricing, applyFees, applyVehicleImages } from "../data/pricing";
import { HERO } from "../mock";

const API = process.env.REACT_APP_BACKEND_URL;

// Fetches admin-managed pricing, night-surcharge fees and site images, then
// applies them to the shared in-memory config. Returns a version counter that
// changes once loaded, forcing a re-render so fares/images reflect admin data.
export function usePricing() {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    let active = true;
    Promise.all([
      fetch(`${API}/api/pricing`).then((r) => r.json()).catch(() => null),
      fetch(`${API}/api/fees`).then((r) => r.json()).catch(() => null),
      fetch(`${API}/api/images`).then((r) => r.json()).catch(() => null),
    ])
      .then(([pricing, fees, images]) => {
        if (!active) return;
        if (pricing) applyPricing(pricing);
        if (fees) applyFees(fees);
        if (images) {
          if (images.hero) HERO.image = images.hero;
          if (images.vehicles) applyVehicleImages(images.vehicles);
        }
        setVersion((v) => v + 1);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);
  return version;
}
